// extracted by mini-css-extract-plugin
module.exports = {"Quiz":"Quiz_Quiz__18Rwf","QuizWrapper":"Quiz_QuizWrapper__c8INT"};